module.exports = __webpack_public_path__ + "static/media/scenery_9.5e4cef7f.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bg/scenery/scenery_9.jpg
// module id = 584
// module chunks = 0